import { registerI18nResources } from '@mc/i18n'
import { GROWTH_I18N } from './constants'
import enUS from './locales/en-US.json'

export const i18nInstance = registerI18nResources({
  namespace: GROWTH_I18N,
  resources: { 'en-US': enUS },
})
